module.exports = __webpack_public_path__ + "static/11-fa193113afd96344aebbc87ab4dfac35.png";